import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { createShipTo, updateShipTo } from "@insite/client-framework/Services/CustomersService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTo";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { AddOrUpdateShipTo, chain, DispatchBeginUpdateCart, ExecuteOnSuccessCallback, PopulateCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import { BaseAddressModel } from "@insite/client-framework/Types/ApiModels";
import { CustomState } from "@midland-industries/Store/Reducers";

type UpdateCartProps = Parameters<typeof DispatchBeginUpdateCart>[0];

async function CustomAddOrUpdateShipTo(props: UpdateCartProps) {    
    const { dispatch, getState, cart } = props;
    const state = getState();
    const {
        pages: {
            checkoutShipping: { shippingAddressFormState },
        },
    } = state;

    if (!shippingAddressFormState) {
        return;
    }

    const shipTo = getShipToState(state, cart.shipToId).value;
    const billTo = getBillToState(state, cart.billToId).value;
    if (!shipTo || !billTo) {
        throw new Error("There was no shipTo or billTo loaded for the current cart");
    }

    if (cart.shipToId === cart.billToId && !shippingAddressFormState.address.oneTimeAddress) {
        return;
    }
    
    const { address: localModifiedShipTo } = shippingAddressFormState;

    if (!customAreAddressesTheSame(shipTo, localModifiedShipTo)) {
        props.updatedShipTo = localModifiedShipTo.isNew
            ? await createShipTo({ shipTo: localModifiedShipTo })
            : await updateShipTo({ shipTo: localModifiedShipTo, billToId: billTo.id });

        dispatch(loadShipTo({ shipToId: props.updatedShipTo.id, billToId: billTo.id }));

        props.apiParameter.cart.shipToId = props.updatedShipTo.id;
    }
}

export const customAreAddressesTheSame = (address1: BaseAddressModel, address2: BaseAddressModel) => {
    const results = address1.firstName === address2.firstName &&
        address1.lastName === address2.lastName &&
        address1.attention === address2.attention &&
        address1.companyName === address2.companyName &&
        address1.address1 === address2.address1 &&
        address1.address2 === address2.address2 &&
        address1.address3 === address2.address3 &&
        address1.address4 === address2.address4 &&
        address1.country?.id === address2.country?.id &&
        address1.city === address2.city &&
        address1.state?.id === address2.state?.id &&
        address1.postalCode === address2.postalCode &&
        address1.phone === address2.phone &&
        address1.email === address2.email &&
        address1.fax === address2.fax &&
        address1.properties === address2.properties;

    return results;
};

replaceInChain(chain, AddOrUpdateShipTo, CustomAddOrUpdateShipTo);